import React, {Component} from 'react'
import PropTypes from 'prop-types'

export default class ShopLink extends Component {
  render () {
    const {
      className,
      link,
      image
    } = this.props

    return (
      <div className={className || 'shoplink'}>
        <a href={link} target='_blank' rel='noopener noreferrer' name='Shop Link'>
          {image &&
            <img src={image} className='shoplink-image' alt='Shop'/>
          }
          {!image &&
            'shop'
          }
        </a>
      </div>
    )
  }
}

ShopLink.propTypes = {
  className: PropTypes.string,
  link: PropTypes.string,
  image: PropTypes.string
}
